module.exports = __webpack_public_path__ + "static/device_laptop_apple_dark-27a7eaed665e00e22436d670359cd83d.png";